"use client";
import { useEffect } from "react";
import { datadogRum } from "@datadog/browser-rum";
import { useSession } from "next-auth/react";
import { WorkspaceChatProvider } from "@/lib/hooks/workspace-chat-context";
import { SessionProvider } from "next-auth/react";
import { Inter } from "next/font/google";
import { initDatadogRum, startSessionReplay, stopSessionReplay } from "@/lib/datadog-rum";
import "./globals.css";

const inter = Inter({ subsets: ["latin"] });

const metadata = {
  title: "Tireco AI",
  description: "This is the AI platform for Tireco.",
};

function DatadogRumUserTracker() {
  const { data: session, status } = useSession();

  useEffect(() => {
    initDatadogRum();
  }, []);

  useEffect(() => {
    if (status === "authenticated" && session?.user) {
      datadogRum.setUser({
        id: session.user.uuid ?? session.user.email ?? "unknown-user",
        email: session.user.email ?? undefined,
        name: session.user.name ?? undefined,
      });
      startSessionReplay();
    } else if (status === "unauthenticated") {
      datadogRum.clearUser();
      stopSessionReplay();
    }
  }, [status, session]);

  return null;
}

export default function RootLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <html lang="en">
      <head>
        <link rel="stylesheet" href="https://use.typekit.net/wzn5geg.css" />
        <title>{metadata.title}</title>
        <meta name="description" content={metadata.description} />
      </head>
      <body className={`${inter.className} bg-white`}>
        <SessionProvider basePath="/web-api/auth">
          <DatadogRumUserTracker />
          <WorkspaceChatProvider>
            {children}
          </WorkspaceChatProvider>
        </SessionProvider>
      </body>
    </html>
  );
}
